import Vue from "vue";
import Vuex from "vuex";
import {
  auth,
  usersCollection,
  // storage,
} from "@/plugins/firebase.js";
import router from "../router/index";
// import createPersistedState from "vuex-persistedstate";
import moment from "moment";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: null,
    datesrange: ['2019-01-01', moment().format('YYYY-MM-DD')],
    datesrangetype: { id: '%m', title: 'month', bigquery_name: 'month' }, 
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setDatesRange(state, payload) {
      state.datesrange = payload;
    },
    setDatesRangeType(state, payload) {
      state.datesrangetype = payload;
    },
  },
  actions: {
    async signUserIn({ dispatch }, payload) {
      // log in user with firebase auth
      const { user } = await auth.signInWithEmailAndPassword(
        payload.email,
        payload.password
      );

      await auth.currentUser.getIdTokenResult(true) // 1
      .then((idTokenResult) => {
        // 2 Confirm the user is an Admin
        if (idTokenResult.claims.admin) { // 3
          // fetch user profile from firestore db and set in state
          dispatch("fetchUserProfile", user);

          router.push("/");
        } else {
          alert("Need admin account");
        }
      })

    },

    async fetchUserProfile({ commit }, user) {
      // fetch user profile
      const userProfile = await usersCollection.doc(user.uid).get();

      const profileDuplicated = { ...userProfile.data() };

      // set user profile in state
      commit("setUser", profileDuplicated);
    },

    async logUserOut({ commit }) {
      // log out user with firebase auth
      await auth.signOut();

      // clear vuex state and redirect user
      commit("setUser", null);
      router.push("/login");
    },

    setDatesRange({ commit }, date) {
      commit("setDatesRange", date);
    },
    setDatesRangeType({ commit }, value) {
      commit("setDatesRangeType", value);
    },
  },

  getters: {
    user(state) {
      return state.user;
    },
    datesrange(state) {
      return state.datesrange;
    },
    datesrangetype(state) {
      return state.datesrangetype;
    },
  },

  modules: {},

  // plugins: [createPersistedState()]
});

export default store;
